export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9422_BEHAVIOUR_': 'Behaviour:',
    '_9986_NO_BEHAVIOUR_SELECTED': 'No Behaviour Selected',
    '_10016_ADD_BEHAVIOUR': 'Add Behaviour',
    '_9423_SUB_BEHAVIOUR_': 'Tactic:',
    '_9987_NO_SUB_BEHAVIOUR_SELECTED': 'No Tactic Selected'
};
